import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import * as storage from 'src/lib/storage';
import type { BackendMutationSignUpArgs, BackendUserAuthStatus } from 'src/types/backend';

const MUTATION = gql`
  mutation SignUp(
    $email: String!
    $password: String!
    $signUpDevice: String!
    $referralToken: String
    $impactClickId: String
  ) {
    signUp(
      email: $email
      password: $password
      signUpDevice: $signUpDevice
      referralToken: $referralToken
      impactClickId: $impactClickId
    ) {
      token
    }
  }
`;

type Variables = Omit<BackendMutationSignUpArgs, 'impactClickId'>;
type Result = BackendUserAuthStatus;

export const register = async ({ email, password, signUpDevice, referralToken }: Variables) => {
  const impactClickId = storage.readItem('impactClickId');
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: { email, password, signUpDevice, referralToken, impactClickId },
  });
  return getSingleProp<Result>(result.data);
};
